var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SettingsMediaUpload',{attrs:{"prop":"portrait_cover","section":"images","label":_vm.$t('_web_competitions_portrait-label', 'Portrait BG:'),"tooltip":_vm.$$t(
      'Portrait is used as a tournament profile background',
      'portrait-tooltip'
    ),"width":3,"height":4,"recommended-width":720,"recommended-height":1080}})}
var staticRenderFns = []

export { render, staticRenderFns }